import { render, staticRenderFns } from "./ModalRetention.vue?vue&type=template&id=017a24da"
import script from "./ModalRetention.vue?vue&type=script&lang=js"
export * from "./ModalRetention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports